import { getApiClient } from '@/lib/api/api-client';

/**
 * Newsletter abonelik işlemleri için API servisi
 */
export class NewsletterAPI {
  /**
   * Yeni bir newsletter abonesi oluşturur
   */
  static async subscribe(email: string) {
    try {
      const apiClient = getApiClient();

      // Yeni abone oluştur
      const response = await apiClient.collections['newsletter-subscribers'].create({
        collection: 'newsletter-subscribers',
        doc: {
          email: email,
        },
      });

      return response;
    } catch (error) {
      console.error(`An error occurred while creating a newsletter subscriber:`, error);
      return null;
    }
  }
}

export async function subscribeToNewsletter(email: string, title: string, dropDate: string) {
  try {
    // API URL'sini oluştur
    let apiUrl = 'http://localhost:3030/api/event-reminder';

    if (process.env.NEXT_PUBLIC_PAYLOAD_API_URL) {
      apiUrl = `${process.env.NEXT_PUBLIC_PAYLOAD_API_URL}/api/event-reminder`;
    } else if (typeof window !== 'undefined') {
      apiUrl = `https://cave.orkhan.art/api/event-reminder`;
    }

    // API'ye istek gönder
 await fetch(apiUrl, {
      method: 'POST',
      mode: 'no-cors',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        email,
        title,
        dropDate,
      }),
    });

    return true;
  } catch (error) {
    console.error('Newsletter subscription error:', error);
    throw error;
  }
}
